import { render } from "./staticDrawer.vue?vue&type=template&id=eaa13ce2&scoped=true"
import script from "./staticDrawer.vue?vue&type=script&lang=js"
export * from "./staticDrawer.vue?vue&type=script&lang=js"

import "./staticDrawer.vue?vue&type=style&index=0&id=eaa13ce2&lang=scss"
import "./staticDrawer.vue?vue&type=style&index=1&id=eaa13ce2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaa13ce2"],['__file',"src/components/staticDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eaa13ce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eaa13ce2', __exports__)) {
    console.log('reload')
    api.reload('eaa13ce2', __exports__)
  }
  
  module.hot.accept("./staticDrawer.vue?vue&type=template&id=eaa13ce2&scoped=true", () => {
    console.log('re-render')
    api.rerender('eaa13ce2', render)
  })

}


export default __exports__